export { PageInfoModule } from './page-info.module';
export { PageInfoService } from './services';
export { PageInfoMode } from './types';
